module.exports = __webpack_public_path__ + "img/edit.43a9c900.svg";